/**
*
* LoginPage
*
*/

import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { Button, Card, Checkbox, H2, Input } from '@pearsontechnology/aero-components';
import { Wrapper, ActionsWrapper, ErrorMessage, Form, InputWrapper, IesWrapper, IesAction } from './styles';
import PearsonInterrobang from '../PearsonInterrobang';
import messages from './messages';
import gtmService from 'utils/gtm/gtmService';
import { GTM_EVENT_TYPES } from 'utils/gtm/constants';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      emailFeedback: '',
      passwordFeedback: '',
      errorMessage: '' || (props && props.errorMessage),
      remember: true,
    };
  }

  componentDidMount() {
    if(!this.props.isLoading) {
      gtmService.gtmTrackEvent({ eventType: GTM_EVENT_TYPES.PAGEVIEW, payload: { pageName: 'Login Page' } });
    }
  }

  componentWillUnmount() {
    this.setFeedback.cancel();
  }

  onChange = (field) => (event) => {
    const newValue = event.target.value;
    this.setState({
      [field]: newValue,
      errorMessage: '',
    });

    // ///////////////  TODO: Create a better validation function  /////////////// //
    const feedback = newValue ? '' : this.props.intl.formatMessage(messages[`${field}EmptyFeedback`]);
    this.setFeedback(`${field}Feedback`, feedback);
  };

  onChangeRemember = (event) => {
    this.setState({
      remember: event.target.checked,
    });
  };

  setFeedback = debounce((field, value) => {
    this.setState({
      [field]: value,
    });
  }, 350);

  handleSubmit = (event) => {
    const { email, password, remember } = this.state;
    event.preventDefault();
    this.props.onSubmit({
      email,
      password,
      remember,
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.errorMessage !== nextProps.errorMessage) {
      this.setState({
        errorMessage: nextProps.errorMessage,
      });
    }
  }

  render() {
    const { email, password, emailFeedback, passwordFeedback, errorMessage, remember } = this.state;
    const { intl, isLoading, isWorkspaceIesV2Enabled, iesV2Login } = this.props;
    
    return (
      <Wrapper>
        <Form onSubmit={this.handleSubmit} method="get" target="_self" action="">
          <Card>
            <PearsonInterrobang />
            <H2><FormattedMessage {...messages.welcome} /></H2>
            <InputWrapper>
              <Input
                type="email"
                value={email}
                feedback={emailFeedback}
                label={intl.formatMessage(messages.email)}
                onChange={this.onChange('email')}
              />
              <Input
                type="password"
                value={password}
                feedback={passwordFeedback}
                label={intl.formatMessage(messages.password)}
                onChange={this.onChange('password')}
              />
            </InputWrapper>
            <ActionsWrapper>
              <Checkbox
                label={intl.formatMessage(messages.remember)}
                checked={remember}
                onChange={this.onChangeRemember}
              />
              <Button type="submit" isLoading={isLoading} primary loadable>
                <FormattedMessage {...messages.submit} />
              </Button>
            </ActionsWrapper>
            <ErrorMessage visible={!!errorMessage} role="alert">
              {errorMessage}
            </ErrorMessage>
          </Card>
        </Form>
        {isWorkspaceIesV2Enabled && (
          <IesWrapper>
            <Card>
              <PearsonInterrobang />
              <IesAction>
                <Button onClick={iesV2Login}>
                  <FormattedMessage {...messages.iesV2} />
                </Button>
              </IesAction>
            </Card>
          </IesWrapper>
        )}
      </Wrapper>
    );
  }
}

LoginPage.propTypes = {
  intl: intlShape.isRequired,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func,
  errorMessage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isWorkspaceIesV2Enabled: PropTypes.bool,
  iesV2Login: PropTypes.func,
};

export default injectIntl(LoginPage);
export class TestLoginPage extends LoginPage {} // Exported for testing purposes.
